import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {useCcDistribuibuivel} from "@components/contaContabil/valoresDistribuiveis/useCcDistribuibuivel.ts";
import {useState} from "react";
import {CcDistribuivelGrid} from "@components/contaContabil/valoresDistribuiveis/infoComponent/CcDistribuivelGrid.tsx";
import {CcDistribuivelRow} from "@components/contaContabil/valoresDistribuiveis/infoComponent/CcDistribuivelRow.tsx";

interface CcDistribuivelInfoProps extends DefaultInfoV1Props<ICcValorDistribuivel> {
    variant: 'grid' | 'row'
}

export function CcDistribuivelInfo(props: CcDistribuivelInfoProps) {
    const {value, variant, expectedId} = props
    const {getCcValorDistribuivelById} = useCcDistribuibuivel()
    const [v, setV] = useState<ICcValorDistribuivel | null>(value)
    if (v == null) {
        if (expectedId == null)
            return <>Valor indefinido...</>

        getCcValorDistribuivelById(expectedId).then(x => {
            if (x) {
                setV(x)
            }
        })
    }

    if (v == null) return (<>...</>)

    switch (variant) {
        case 'grid':
            return (<CcDistribuivelGrid {...props} value={v}/>)
        case 'row':
            return (<CcDistribuivelRow {...props} value={v}/>)
        default:
            return (<>...</>)
    }
}